import { Helmet } from 'react-helmet'
import MainHeader from '../../../components/MainHeader'
import MainFooter from '../../../components/MainFooter'
import CTAButton from '../../../components/CTAButton.js'
import HorizontalScrollSlider from '../../../components/HorizontalScrollSlider.js'
import BackButton from '../../../components/MainComponents.js'

import { motion } from "framer-motion";

import './ServiceAppdev.css'
import './MServiceAppdev.css'
import { boxvar1, boxvar2, boxvar2_1, boxvar2_2, boxvar2_3, boxvar2dyndelay, boxvar4, oPU } from '../../../core.js'
// import { } from '@fortawesome/free-solid-svg-icons';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import example_selfcoded from '../../../assets/pictures/sectionimages/example_selfcoded_compressed.webp'
import example_cmswebstudio from '../../../assets/pictures/sectionimages/example_cmswebstudio_compressed.webp'
import example_codecms_combined from '../../../assets/pictures/sectionimages/example_codecms_combined_compressed.webp'

var slides = [
    { img: example_selfcoded, caption: "Interne Tools 🛠️", description: "", bg: "var(--ci_color_tilebg)" },
    { img: example_codecms_combined, caption: "Kunden-Apps 🛍️", description: "", bg: "var(--ci_color_primary)" },
    { img: example_cmswebstudio, caption: "Mobile Games 🎲", description: "", bg: "var(--ci_color_tilebg)" },

];

export default function ServiceAppdev() {

    return (
        <div className='mainCon' id='mainCon'>

            <MainHeader selectedsite={"services"} disableanimation={false} />

            <Helmet>
                <meta charSet="utf-8" />
                <title>ToN - Appentwicklung</title>
                <meta property="og:title" content="Appentwicklung on Demand" />
                <meta property="og:description" content="Wir bieten dir ein breites Spektrum an Dienstleistungen, einer unserer Key-Services: Appentwicklung" />
                <meta name="description" content="Wir bieten dir ein breites Spektrum an Dienstleistungen, einer unserer Key-Services: Appentwicklung" />
            </Helmet>
            <section className='sec_next' id='sec_next--service-appdev'>
                <div className='sec_next_cont' id="sec_next--service-appdev--cont" style={{ wordBreak: "break-word" }}>
                    <BackButton href='/services' />


                    <motion.div variants={boxvar2_1} className='about_section_cont' initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}>
                        <br />
                        <h2>Deine App - ganz easy.</h2>
                        <h3>Für deine Kunden. Für deine Mitarbeiter.</h3>
                        <p>
                            Apps können in den verschiedensten Bereichen eingesetzt werden.<br />
                            Das reicht von einfachen Tools für deine Mitarbeiter, bis hin zu Membership-Apps, mit denen du ganze End-to-End-Prozesse abdecken kannst.<br />
                            Deine Kunden können so bspw. direkt über ihr Handy bei dir bestellen und haben dabei eine sehr persönliche Customer Experience, die von Angebot bis Support an einem Ort stattfindet.
                        </p>


                        {/* <motion.div variants={boxvar4} style={{}} className='' initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}>

                            <HorizontalScrollSlider slides={slides} />

                        </motion.div> */}


                    </motion.div>


                    <motion.div variants={boxvar2_1} style={{}} className='' initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}>
                        <h2>Du hast die Wahl.</h2>

                        <h3>Web, Android, iOS - überall.</h3>
                        <p>
                            Unsere Apps entwickeln wir so, dass du sie überall nutzen kannst - ganz egal, ob nur mobil oder in Kombination mit einer Webapp.<br />
                            Das bringt nicht nur Flexibilität, sondern spart auch Kosten.<br />
                        </p>
                    </motion.div>

                    <br /><br />

                    <motion.div variants={boxvar2_1} style={{}} className='' initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}>

                        <h2>Unsere Leistungen</h2>
                        <p>
                            Wir decken den Bereich Appentwicklung End-to-End ab, d.h. von der Planung bis hin zur Wartung der App, aber auch der Entwicklung der zugehörigen Serverinfrastruktur.<br />
                            Bevor es losgeht, beraten wir dich ausführlich und zeigen dir wie deine Idee am optimalsten für dich umgesetzt werden kann.<br />
                            Dabei kommen über 5 Jahre Erfahrung im Bereich Appentwicklung zum Tragen.<br />
                            Im Konzeptionsprozess erarbeiten wir außerdem gemeinsam mit dir ein vollständiges Corporate Design, falls noch nicht vorhanden und sorgen damit für einen einheitlichen Außenauftritt.
                        </p>
                    </motion.div>

                    <br /><br />

                    <motion.div variants={boxvar2_1} style={{}} className='' initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}>

                        <h2>Warum wir?</h2>
                        <ul>
                            <li>Wir bieten dir einen Rundum-Service, damit du dich entsptannt auf dein Business konzentrieren kannst. Das reicht von Appdesign, AI-Entwicklung bis hin zu Content-Creation.</li>
                            <li>Wir stehen dir auch nach Abschluss des Projekts als langjähriger Partner zur Seite</li>
                            <li>Langjährige Erfahrung in der Softwareentwicklung mit Spezialisierung auf Webentwicklung und Projektmanagement</li>
                            <li>Best Practices = Our Practices. Selbstverständlich nutzen wir branchenübliche Tools wie Git-Versionierung, CI/CD oder Code-Automatisierung</li>
                            <li>Unsere Leistungen sind unabhängig von der Größe deines Projekts</li>

                        </ul>


                    </motion.div>

                    <br /><br /><br /><br />


                    <motion.div variants={boxvar2_1} style={{}} className='' initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}>
                        <h2>Was kostet das?</h2>
                        <p>
                            Eine transparente Preisübersicht findest du auf unserer Preise-Seite. Alle dort genannten Beträge sind <b>Listenpreise ohne Rabatte</b> und werden individuell auf dein Projekt zugeschnitten.
                        </p>
                        <br />
                        <CTAButton className="" showArrow={true} customIcon={null} iconLeft={false} title={"Zu den Preisen"} href={'/pricing'}></CTAButton>
                    </motion.div>

                    <br /><br /><br /><br />

                    <motion.div variants={boxvar2dyndelay} className='small_services_box small_services_box-bigbottom' initial="hidden" exit="hidden" whileInView="visible" custom={0.3} viewport={{ once: false, margin: "-50px" }}>
                        <div className='small_services_textbox'>
                            <h3>&lt;Individuelle Entwicklung und Beratung/&gt;</h3>
                            <br /><br />
                            <p>
                                Du bist bei unseren Leistungen nicht fündig geworden? Wir sind offen für Herausforderungen 😉<br />
                                Wir stehen dir mit Expertise zur Seite und entwickeln bspw. ein Branding für deine Marke, eine Elektronikkomponente oder eine individuelle Softwarelösung für dich.
                            </p>
                            <CTAButton className="" showArrow={true} customIcon={null} iconLeft={false} title={"Jetzt anfragen"} href={'/support'}></CTAButton>
                        </div>
                    </motion.div>

                    <br /><br /><br /><br />
                </div>
            </section >

            <MainFooter />
        </div >
    )
}
